import React from "react";

function extractImageNode(children) {
  return (
    Array.isArray(children) &&
    children.find(child => {
      if (child?.props?.originalType === "img") {
        return true;
      }

      return false;
    })
  );
}

export function a({ href = "#", children }) {
  const isExternal = href.startsWith("http");

  const firstImage = Array.isArray(children)
    ? extractImageNode(children)
    : children &&
      typeof children === "object" &&
      Array.isArray(children?.props?.children) &&
      extractImageNode(children.props.children);

  const anchorText =
    typeof children === "string"
      ? children
      : firstImage
      ? firstImage?.props?.alt + " (" + firstImage?.props?.src + ")"
      : "UNKNOWN";

  const cleanAnchorText = anchorText.replace(/"/g, "");

  return (
    <a
      href={href}
      target={isExternal ? "_blank" : null}
      data-tracking-action-label={`LINK.${
        isExternal ? "EXTERNAL" : "INTERNAL"
      }`}
      data-tracking-action-value={`${cleanAnchorText} | ${href}`}
      data-tracking-action-position="IN ARTICLE"
      rel="noopener noreferrer"
      className="border-b-2 border-pink-300 hover:border-pink-500 transition duration-200 no-underline pb-0.5 hover:text-pink-500"
      style={{ textDecoration: "none" }}
    >
      {children}
    </a>
  );
}
